import {
  ChangeDetectorRef,
  Component,
  Inject,
  PLATFORM_ID,
} from '@angular/core';
import { Auction } from '../../_interfaces/auction.interface';
import { AuctionService } from '../../_services/auction/auction.service';
import { ToastService } from 'src/app/Shared/services/toast/toast.service';
import { BuyerAuthService } from 'src/app/app-modules/buyer/buyer-core/buyer-authentication/services/buyer-auth/buyer-auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Meta, Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

import { PusherService } from 'src/app/Shared/services/pusher/pusher.service';
import { StorageService } from 'src/app/Core/_services/storage/storage.service';
import {
  changeAuctionsStatuses,
  getAuctionsData,
} from 'src/app/_utlis/auctions-helpers';
import { IPagination } from 'src/app/Shared/_models/pagination.model';
import {
  CardsPerPage,
  getPaginationData,
} from 'src/app/_utlis/pagination-helper';
import { PageHeaderComponent } from '../../../../../../Shared/components/page-header/page-header.component';
import { BuyerPageOptionsComponent } from '../../../../buyer-shared/components/buyer-page-options/buyer-page-options.component';
import { SearchInputComponent } from '../../../../../../Shared/components/search/search-input.component';
import { PaginationResultsComponent } from '../../../../../../Shared/components/pagination-results/pagination-results.component';
import { ReactiveFormsModule } from '@angular/forms';

import { BuyerAuctionCardComponent } from '../../../../buyer-shared/components/buyer-auction-card/buyer-auction-card.component';
import { NoDataComponent } from '../../../../../../Shared/components/no-data/no-data.component';
import { PaginationComponent } from '../../../../../../Shared/components/pagination/pagination.component';
import { isPlatformBrowser } from '@angular/common';
import { TranslatePipe, TranslateService} from '@ngx-translate/core';
import { Breadcrumb } from 'src/app/Shared/_models/breadcrumb.model';
import { TermsAndConditionsAcceptanceService } from 'src/app/app-modules/buyer/buyer-shared/services/terms-and-conditions-acceptance.service';
import {
  ITermsAndConditionsPayload,
  IBuyerApplicationStatusPayload,
  IAuctionUpdateEventPayload,
} from 'src/app/Shared/_models/pusher-events-payload.model';
import { getAuctionChannels } from '../../_PusherEvents/auction-pusher-events';
import * as Events from 'src/app/_contstants/pusher-contstants';

@Component({
    selector: 'app-buyer-upcoming-auctions',
        standalone: true,
templateUrl: './buyer-upcoming-auctions.component.html',
    styleUrls: ['./buyer-upcoming-auctions.component.scss'],
    imports: [
    PageHeaderComponent,
    BuyerPageOptionsComponent,
    SearchInputComponent,
    PaginationResultsComponent,
    ReactiveFormsModule,
    BuyerAuctionCardComponent,
    NoDataComponent,
    PaginationComponent,
    TranslatePipe
]
})
export class BuyerUpcomingAuctionsComponent {
  isLoading!: boolean;
  auctionType = 'upcoming';
  searchVal = '';
  auctions: any[] = [];
  loggedIn = false;
  sub!: Subscription;
  breadcrumbs: Breadcrumb[] = [
    {
      label: 'Home',
      url: environment.wordpressUrl,
      translationKey: 'auction_home',
    },
    {
      label: 'Upcoming Auctions',
      url: '',
      translationKey: 'auction_upcoming_auctions',
    },
  ];
  currentLang: any;
  timer!: any;

  user_id!: number;
  page: number = 1;
  itemsPerPage: number = CardsPerPage;

  paginationData!: {
    totalPages: number;
    total: number | undefined;
    from: number | undefined;
    to: number | undefined;
  };
  calledFirstTime!: boolean;
  isBrowser: boolean;
  termsSub!: Subscription;
  private subscriptions = new Subscription();

  constructor(
    private auctionService: AuctionService,
    private toastService: ToastService,
    private auth: BuyerAuthService,
    private router: Router,
    private titleService: Title,
    private translate: TranslateService,
    private pusherService: PusherService,
    private storage: StorageService,
    private route: ActivatedRoute,
    private meta: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private termsAcceptance: TermsAndConditionsAcceptanceService,
    private cdr: ChangeDetectorRef
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    if (this.isBrowser) {
      this.currentLang = JSON.parse(
        localStorage.getItem(this.storage.getPrefixedKey('selectedLang')) ?? '{}'
      );
    }
  }
  ngOnInit(): void {
    this.initializeMetaTags();
    this, this.initializeAuthSubscription();
    if (this.isBrowser) {
      // this.subscribeToAuctionChannel();
      this.subscribeToAcceptedTerms();
    }
    this.initializeRouteSubscription();
  }
  initializeMetaTags() {
    this.titleService.setTitle('Upcoming Auctions | Mark Your Calendar');
    this.meta.addTag({
      name: 'description',
      content:
        'Get excited about our upcoming horse auctions. Discover the latest horses that will be available for bidding soon.',
    });
  }

  initializeAuthSubscription() {
    const authSub = this.auth.loggedIn_authorized$.subscribe((res) => {
      this.loggedIn = res;
      if (this.calledFirstTime) {
        this.getAuctions();
      }

      this.unSubscribeFromChannels();
      this.user_id = this.storage?.userData?.id;
      this.subscribeToChannels();
    });
    this.subscriptions.add(authSub);
  }

  initializeRouteSubscription() {
    const routeSub = this.route.queryParams.subscribe((params) => {
      this.page = +params['page'];
      this.searchVal = params['search'] || '';
      this.getAuctions();
    });
    this.subscriptions.add(routeSub);
  }
  resetSearch() {
    this.router.navigate(['/buyer/auctions/upcoming']);

    // this.getAuctions();
  }
  getAuctions(reload = true) {
    if (reload) {
      this.isLoading = true;
    }
    this.toastService.clear();

    this.auctionService
      .getUpcomingAuctions(this.searchVal, this.page || 1, this.itemsPerPage)
      .subscribe({
        next: (response: {
          data: { items: Auction[]; pagination: IPagination };
          current_datetime: Date;
        }) => {
          this.auctions = getAuctionsData(response);
          this.paginationData = getPaginationData(
            response.data.pagination,
            this.itemsPerPage
          );
        },
        error: (error) => {
          this.toastService.showError(error?.error?.Error[0]);
        },
        complete: () => {
          this.isLoading = false;
        },
      });
  }

  handleActions(e: { action: string; data: Auction }) {
    const { action, data } = e;
    switch (action) {
      case 'time_ended':
        const filteredData = this.auctions.filter((el) => el?.id != data?.id);
        this.auctions = [...filteredData];
        break;
    }
  }

  handleSearch(search: string) {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      const queryParams: any = { search };

      this.router.navigate(['/buyer/auctions/upcoming'], { queryParams });
    }, 1500);
  }
  cardClicked(e: any, item: any) {
    e.stopPropagation();

    const queryParams = {
      auctionTypePage: 'upcoming',
    };
    this.router.navigate(['/buyer/auctions', item.slug], { queryParams });
  }
  subscribeToAcceptedTerms() {
    const termsSub = this.termsAcceptance.buyerAccepted$.subscribe((value) => {
      if (value?.isAccepted === 'accepted') {
        this.auctions.forEach((element: any) => {
          if (element?.id === value?.auctionId) {
            element.buyer_accepted_seller_terms = value?.isAccepted;
          }
        });
        this.cdr.detectChanges();
      }
    });
    this.subscriptions.add(termsSub);
  }

  onPageChanged(page: number): void {
    const queryParams: any = { page };
    if (this.searchVal) {
      queryParams.search = this.searchVal;
    }

    this.router.navigate(['/buyer/auctions/upcoming'], {
      queryParams,
    });
  }

  subscribeToChannels() {
    const channels = getAuctionChannels(this.user_id);
    this.pusherService.subscribeToMultiChannels(channels, (data: any) => {
      this.handlePusherEvents(data);
    });
  }

  handlePusherEvents(eventData: { eventName: string; data: any }) {
    const { eventName, data } = eventData;
    switch (eventName) {
      case Events.TERMS_CONDITIONS_UPDATE:
        this.handleTermsAndConditionUpdatedEvent(data);
        break;

      case Events.BUYER_APP_ACCEPTED:
        this.handleBuyerAppEvent(data, true);
        break;

      case Events.BUYER_APP_REJECTED:
        this.handleBuyerAppEvent(data, false);
        break;

      case Events.AUCTION_UPDATED:
        this.handleAuctionUpdate(data);
        break;
    }
  }

  handleTermsAndConditionUpdatedEvent(data: ITermsAndConditionsPayload) {
    if (data?.affected_auctions) {
      data?.affected_auctions.forEach((element: number) => {
        const matchedAuction = this.auctions.find(
          (auc: any) => auc.id === element
        );

        if (matchedAuction) {
          matchedAuction.seller_terms = data?.terms_and_conditions;
          matchedAuction.buyer_accepted_seller_terms = 'not accepted';
        }
      });
    }
  }

  handleBuyerAppEvent(data: IBuyerApplicationStatusPayload, accepted: boolean) {
    if (data.auction_ids) {
      this.auctions = [
        ...changeAuctionsStatuses(data.auction_ids, accepted, this.auctions),
      ];
    }
    if (accepted) {
      this.getAuctions(false);
    }
  }

  handleAuctionUpdate(data: IAuctionUpdateEventPayload) {
    const auctionIn = this.auctions.findIndex(
      (el) => el?.id == data?.auction_id
    );
    if (data?.status?.upcoming) {
      if (auctionIn === -1) {
        this.getAuctions(false);
      }
    }
  }

  unSubscribeFromChannels() {
    const channels = getAuctionChannels(this.user_id).map(
      (el) => el.channelName
    );

    if (channels.length) {
      this.pusherService.unsubscribeFromChannels(channels);
    }
  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    this.unSubscribeFromChannels();

    if (this.timer) {
      clearTimeout(this.timer);
    }
  }
}
